module.exports = __webpack_public_path__ + "img/智慧屏场景_智能魔镜.46c47bdd.png";